"use client";

// مرز code-split سمت client: dynamic() فقط داخل کامپوننت client چانک جدا می‌سازد
// (از Server Component همه‌ی کد client صفحه‌ها در یک چانک مشترک می‌آمد).
import dynamic from "next/dynamic";
import Loading from "./_loading";

const Component = dynamic(() => import("./_component"), {
  loading: () => <Loading />,
});

export default Component;
